<template>
  <b-container fluid>
    <div v-if="Object.keys(device).length">
      <Breadcrumbs
        v-if="device.substation"
        :project="device.substation.project"
        :substation="device.substation"
        :guard1000="device"
      />
      <loader
        :watch="['guard1000', 'guard1000FaultPanelData', 'guard1000FaultElectricalDataImpedance']"
      >
        <router-view />
      </loader>
    </div>
    <div v-if="!device && !isLoading" class="device-not-found">
      <b-row>
        <b-col cols="6">
          <b-alert variant="secondary" show>
            Device not found
          </b-alert>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import Breadcrumbs from '@/components/shared/breadcrumbs';
import { mapState, mapGetters } from 'vuex';

const STORES_TO_RESET = [
  'guard1000',
  'guard1000FaultPanelData',
  'guard1000FaultEvents',
  'guard1000FaultWaveforms',
  'guard1000FaultElectricalDataImpedance'
];
export default {
  name: 'Guard1000Default',
  components: { Breadcrumbs },
  computed: {
    ...mapState({ device: state => state.guard1000.data }),
    ...mapGetters({ activeLoaders: 'activeLoaders' }),
    isLoading() {
      return Object.keys(this.activeLoaders).filter(loaderKey => this.activeLoaders[loaderKey])
        .length;
    }
  },
  mounted() {
    const { projectCode, substationCode, externalGuardId } = this.$route.params;

    this.$store.dispatch('guard1000/fetchGuard1000', {
      projectCode,
      substationCode,
      externalGuardId
    });
  },
  beforeDestroy() {
    STORES_TO_RESET.forEach(storeName => this.$store.commit(`${storeName}/resetStore`));
  }
};
</script>
